import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

// oauthProviderClient joint automatiquement la requête OAuth signée (présente
// dans l'URL pendant la connexion d'un connecteur) aux appels de connexion.
// La seconde étape (code TOTP) est gérée par le formulaire de connexion lui-même.
export const authClient = createAuthClient({ plugins: [oauthProviderClient(), twoFactorClient()] });

/**
 * Indique si Better Auth a renvoyé une redirection (flux OAuth du connecteur).
 * Une réponse `{ redirect: true, url }` est déjà suivie par le client Better
 * Auth : on ne navigue nous-mêmes que dans les autres cas.
 */
export function followAuthRedirect(data: unknown): boolean {
  const d = data as { redirect?: unknown; url?: unknown; redirect_uri?: unknown } | null;
  const target = d?.url ?? d?.redirect_uri;
  if (typeof target !== "string" || !target) return false;
  if (d?.redirect !== true) window.location.href = target;
  return true;
}
